// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2HOOS","question":"Question_question__37CxS","description":"Question_description__2ucQn"};